import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-slate-900/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="text-2xl font-bold text-white group-hover:text-amber-400 transition-colors duration-300" style={{ fontFamily: "'Staatliches', cursive" }}>
              La Bottega Dei Briganti
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-200 hover:text-amber-400 transition-colors duration-200 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className="text-gray-200 hover:text-amber-400 transition-colors duration-200 font-medium"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('eventi')}
              className="text-gray-200 hover:text-amber-400 transition-colors duration-200 font-medium"
            >
              Eventi
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="text-gray-200 hover:text-amber-400 transition-colors duration-200 font-medium"
            >
              Contatti
            </button>
            <a href="tel:+390522886705">
              <Button
                variant="outline"
                size="sm"
                className="border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-slate-900 transition-all duration-300"
              >
                <Phone className="w-4 h-4 mr-2" />
                Chiama Ora
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white hover:text-amber-400 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-slate-900/98 backdrop-blur-md border-t border-slate-800">
          <div className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-gray-200 hover:text-amber-400 transition-colors py-2 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className="block w-full text-left text-gray-200 hover:text-amber-400 transition-colors py-2 font-medium"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('eventi')}
              className="block w-full text-left text-gray-200 hover:text-amber-400 transition-colors py-2 font-medium"
            >
              Eventi
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="block w-full text-left text-gray-200 hover:text-amber-400 transition-colors py-2 font-medium"
            >
              Contatti
            </button>
            <a href="tel:+390522886705" className="block">
              <Button
                variant="outline"
                className="w-full border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-slate-900"
              >
                <Phone className="w-4 h-4 mr-2" />
                Chiama Ora
              </Button>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
